<form [formGroup]="searchForm" autocomplete="off">
  <div
    class="form-controls-padding"
    style="margin-top: 15px; margin-bottom: 10px"
  >
    <mat-form-field appearance="outline" hideRequiredMarker="true">
      <mat-label i18n="@@searchLocationsLabel">Search locations</mat-label>
      <input
        matInput
        type="text"
        formControlName="filter"
        placeholder="Search locations"
        (keyup)="onFilterChanged($event)"
        i18n-placeholder="@@searchLocationsPlaceholder"
      />
      <mat-icon class="search-icon-wrapper" matSuffix>search</mat-icon>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label i18n="@@sortLabel">Sort</mat-label>
      <mat-select
        [hideSingleSelectionIndicator]="true"
        formControlName="sort"
        (selectionChange)="onSortChanged($event)"
      >
        @for (option of sortOptions; track option) {
          <mat-option [value]="option.value">
            {{ option.display }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <div class="selection-controls">
      @if (selectionMode === 'multiple' && (totalCount ?? 0) > 1) {
        <div>
          <mat-checkbox
            [checked]="allSelected"
            (change)="selectAll($event)"
            i18n="@@allCheckbox"
          >
            All
          </mat-checkbox>
        </div>
      }
      @if ((totalCount ?? 0) > 1) {
        <mat-checkbox
          [checked]="isSelected"
          (change)="toggleSelection($event)"
          i18n="@@multiSelectCheckbox"
        >
          Multi-select
        </mat-checkbox>
      }
      @if (
        showSummaryStatsReport &&
        (layoutService.isDesktopView$ | async) &&
        totalCount! > 0
      ) {
        <a
          (click)="onStatsClick()"
          class="link-text"
          i18n="@@summaryStatsTitle"
        >
          Catchment list
        </a>
      }
    </div>

    @if (totalCount! > 0) {
      <div class="list-summary list-summary-with-button">
        <ng-container i18n="@@locationsSummary">
          Locations ({{ countMessage$ | async }})
        </ng-container>
      </div>
    }

    <div class="list-container">
      <dx-data-grid
        [ngStyle]="{
          'padding-top': '10px',
          'padding-bottom': '10px',
          width: '290px',
          height:
            (layoutService.isDesktopView$ | async)
              ? 'calc(100vh - 55vh)'
              : '100%'
        }"
        atlasDxiRowSelectionTemplate
        id="locationGrid"
        class="standard-grid"
        noDataText="There are currently no locations in this library."
        [dataSource]="customDataSource"
        [showColumnHeaders]="false"
        [showRowLines]="false"
        [showBorders]="false"
        [focusedRowEnabled]="true"
        [autoNavigateToFocusedRow]="true"
        [remoteOperations]="true"
        [columnAutoWidth]="true"
        [selection]="{ mode: selectionMode }"
        [columnWidth]="columnWidth"
        [focusedRowKey]="selectedLocationId"
        (onSelectionChanged)="onSelectionChanged($event)"
        i18n-noDataText="@@noLocationsText"
      >
        <dxo-load-panel [enabled]="true"></dxo-load-panel>

        <dxo-scrolling
          mode="virtual"
          rowRenderingMode="virtual"
          [renderAsync]="true"
          [showScrollbar]="
            (layoutService.isDesktopView$ | async) ? 'onScroll' : 'always'
          "
        ></dxo-scrolling>
        <dxo-paging [pageSize]="100"></dxo-paging>

        <dxi-column
          atlasDxiColumnGeocodeTemplate
          width="22"
          dataField="matchLevel"
          caption=""
          [allowSorting]="true"
        ></dxi-column>

        <dxi-column
          dataField="name"
          caption="Name"
          sortOrder="asc"
          class="truncate-text"
          i18n-caption="@@nameCaption"
        ></dxi-column>

        <dxi-column
          dataField="createDt"
          [visible]="false"
          [allowSorting]="true"
        ></dxi-column>

        <dxi-column
          dataField="editedDt"
          [visible]="false"
          [allowSorting]="true"
        ></dxi-column>

        <dxi-column
          [dataField]="getShapeCountDataField()"
          caption=""
          alignment="center"
          cellTemplate="cellTemplate"
          [allowSearch]="false"
        ></dxi-column>
        <div *dxTemplate="let cell of 'cellTemplate'">
          <div class="atlas-dxi-shape-count-column">{{ cell.text }}</div>
        </div>
      </dx-data-grid>
    </div>
  </div>
</form>
